import React__default from 'react';
import classnames from 'classnames';
import { DataLayer } from '@grandvisionhq/analytics';
import { MediaQuery, Button } from '@grandvisionhq/common';
import { useIntl, useFeatureToggles } from '@grandvisionhq/state';
import { isModifiedClickEvent } from '@grandvisionhq/utils';
import { updateActiveVariant } from '../../../context/actions.js';
import { ProductAnalyticsEvents } from '../../Analytics/events/ProductAnalyticsEvents.js';
import { WITHOUT_RX, WITH_RX } from '../components/RxableSelect/contants.js';
import { useProductDetailSlots } from '../../../slots/context.js';
import { useVto } from '../../VTO/context/VtoProvider.js';
import { mapGraphVariantsToVirtualMirror } from '../../VTO/VirtualMirror/mappers/mapGraphVariantsToVirtualMirror.js';
import { isRxRadioSelection } from '../components/RxableSelect/is-rx-radio-selection.js';
import { CTA } from '../components/CTA/Cta.js';
import { Tags } from '../components/Tags/Tags.js';
import { StarRatingReview } from '../../Reviews/StarRatingReview.js';
import { ProductStockIndicator } from '../components/StockIndicator/ProductStockIndicator.js';
import { FacetPickerColor } from '../components/FacetPickers/FacetPickerColor/FacetPickerColor.js';
import { SunglassesRxableSelectContainer } from '../components/SunglassesRxableSelect/SunglassesRxableSelectContainer.js';
import { FacetPickerSize } from '../components/FacetPickers/FacetPickerSize/FacetPickerSize.js';
import ClickAndReserve from '../../ClickAndReserve/components/ClickAndReserveContainer.js';
import { VirtualMirrorModal } from '../../VTO/VirtualMirror/components/VirtualMirrorModal/VirtualMirrorModal.js';
import { useProductData } from '../../../context/ProductContext.js';
import { useCmsData } from '../../../context/CmsContext.js';
import { getActiveBrandPromotion } from '../../../utils/get-active-brand-promotion.js';
import { getFacetPickerConfig } from '../utils/get-facet-picker-config.js';
import { PriceSection } from '../components/PriceSection/PriceSection.js';
import { TryOnButton } from '../../VTO/components/TryOnButton/TryOnButton.js';

const SunglassesEcommContent = ({ className , showOnlyCTA , ctaRef  })=>{
    var ref;
    const isMobile = MediaQuery.useIsBelow(MediaQuery.BreakpointName.TABLET_LANDSCAPE);
    const { getLabel  } = useIntl();
    const { activeVariant: { displayName , sku: activeSku , stock , isVtoEnabled , isExcludedFromCheckout  } , product , dispatch ,  } = useProductData();
    const { brandPromotions  } = useCmsData();
    const { facetTree , isOfferedWithPrescriptions , productType , brandName , variants  } = product;
    const [selectWithRxLens, setSelectWithRxLens] = React__default.useState(WITHOUT_RX);
    var ref1;
    const shouldOpenConfigurator = (ref1 = isOfferedWithPrescriptions && selectWithRxLens === WITH_RX) !== null && ref1 !== void 0 ? ref1 : false;
    const openConfiguratorButtonRef = React__default.useRef(null);
    const [configuratorIsLoading] = React__default.useState(false);
    const [notificationType, setNotificationType] = React__default.useState(undefined);
    const [userHasSelectedASize, setUserHasSelectedASize] = React__default.useState(false);
    const [isConfiguratorOpen, setIsConfiguratorOpen] = React__default.useState(false);
    const { Slots  } = useProductDetailSlots();
    const { featureConfigs  } = useFeatureToggles();
    const { isVtoActive , isVtoFeatureEnabled  } = useVto();
    const isVirtualMirrorEnabled = isVtoFeatureEnabled && isVtoEnabled && (featureConfigs === null || featureConfigs === void 0 ? void 0 : featureConfigs.virtualTryOn) === 'VIRTUAL_MIRROR';
    const brandLogo = (ref = getActiveBrandPromotion(brandName, brandPromotions)) === null || ref === void 0 ? void 0 : ref.logo;
    const mappedVTOVariants = isVirtualMirrorEnabled ? mapGraphVariantsToVirtualMirror(product, variants, activeSku, brandLogo) : undefined;
    const { activeParentFacet: activeColorFacet , activeChildFacet: activeSizeFacet , colorFacets , sizeFacets , showParentFacetPicker: showColorFacets , requiresUserSizeSelection ,  } = getFacetPickerConfig(facetTree, activeSku);
    const hasSingleSizeFacet = React__default.useMemo(()=>{
        return sizeFacets && (sizeFacets === null || sizeFacets === void 0 ? void 0 : sizeFacets.length) === 1;
    }, [
        sizeFacets
    ]);
    const showActiveSizeFacet = React__default.useMemo(()=>hasSingleSizeFacet || requiresUserSizeSelection && userHasSelectedASize
    , [
        hasSingleSizeFacet,
        requiresUserSizeSelection,
        userHasSelectedASize
    ]);
    const showSizeFacets = sizeFacets && (sizeFacets === null || sizeFacets === void 0 ? void 0 : sizeFacets.length) > 0;
    const isValid = React__default.useMemo(()=>!requiresUserSizeSelection || requiresUserSizeSelection && userHasSelectedASize
    , [
        requiresUserSizeSelection,
        userHasSelectedASize
    ]);
    const onRxRadioChange = React__default.useCallback((newSelection)=>{
        if (isRxRadioSelection(newSelection) && selectWithRxLens !== newSelection) {
            setSelectWithRxLens(newSelection);
            ProductAnalyticsEvents.pushPdpSunglassesRxSelectionEvent('click on button', newSelection === WITH_RX ? DataLayer.DataLayerTypes.GlassLensPrescriptionType.Prescription : DataLayer.DataLayerTypes.GlassLensPrescriptionType.NonPrescription);
        }
    }, [
        selectWithRxLens
    ]);
    const handleConfiguratorOpen = ()=>{
        setIsConfiguratorOpen(true);
    };
    const handleConfiguratorClose = ()=>{
        setIsConfiguratorOpen(false);
    };
    const handleConversionEvent = React__default.useCallback(()=>{
    // @TODO: handle conversion event in #
    // Possibly we will need to add this to products-details-v2
    }, []);
    const handleVariantSelection = React__default.useCallback(({ event , sku , href  })=>{
        // Allow customers to open another variant in a new tab or window, otherwise prevent navigation
        if (!event || !isModifiedClickEvent(event)) {
            event === null || event === void 0 ? void 0 : event.preventDefault();
            dispatch(updateActiveVariant({
                sku
            }));
            window.history.replaceState(null, '', href);
        }
    }, [
        dispatch
    ]);
    const handleColorFacetSelection = (props)=>{
        const { name , sku , facetTerm  } = props;
        ProductAnalyticsEvents.pushPdpVariantClickEvent({
            type: productType,
            name,
            id: sku,
            dimension147: facetTerm
        });
        setUserHasSelectedASize(false);
        setNotificationType('info');
        handleVariantSelection(props);
    };
    const handleSizeFacetSelection = (props)=>{
        const { name , sku , facetTerm  } = props;
        ProductAnalyticsEvents.pushPdpVariantClickEvent({
            type: productType,
            name,
            id: sku,
            frameSize: facetTerm
        });
        setUserHasSelectedASize(true);
        handleVariantSelection(props);
    };
    const onAddToCartSuccess = React__default.useCallback(()=>{
    // @TODO: in a future story, this is where the data analytics will be triggered
    }, []);
    const triggerAlertMessage = React__default.useCallback(()=>{
        setNotificationType('error');
    }, []);
    const CTAButton = !isValid ? /**
     * This is a dummy button that triggers an error message if
     * the add-to-cart flow is not yet valid (i.e. the user still needs to pick a size)
     */ /*#__PURE__*/ React__default.createElement(Button, {
        onClick: triggerAlertMessage,
        caption: getLabel('products.actions.addToCart')
    }) : /*#__PURE__*/ React__default.createElement(CTA, {
        isLoading: configuratorIsLoading,
        shouldOpenConfigurator: shouldOpenConfigurator,
        handleConfiguratorOpen: handleConfiguratorOpen,
        handleConversionEvent: handleConversionEvent,
        buttonRef: openConfiguratorButtonRef,
        onAddToCartSuccess: onAddToCartSuccess
    });
    if (showOnlyCTA) {
        return /*#__PURE__*/ React__default.createElement(React__default.Fragment, null, CTAButton);
    }
    return /*#__PURE__*/ React__default.createElement("section", {
        "aria-label": displayName,
        className: classnames('sunglasses-ecomm-content', className)
    }, /*#__PURE__*/ React__default.createElement(Tags, null), /*#__PURE__*/ React__default.createElement("div", {
        className: "sunglasses-ecomm-content__section"
    }, /*#__PURE__*/ React__default.createElement(PriceSection, null), !isMobile && /*#__PURE__*/ React__default.createElement(StarRatingReview, {
        className: "sunglasses-ecomm-content__star-review"
    })), !showColorFacets && /*#__PURE__*/ React__default.createElement("div", {
        className: "sunglasses-ecomm-content__single-facet-term sunglasses-ecomm-content__section"
    }, activeColorFacet && /*#__PURE__*/ React__default.createElement("div", null, activeColorFacet.facetTerm), !showSizeFacets && /*#__PURE__*/ React__default.createElement(ProductStockIndicator, null)), showColorFacets && /*#__PURE__*/ React__default.createElement(FacetPickerColor, {
        className: "sunglasses-ecomm-content__section",
        activeFacet: activeColorFacet,
        onPick: handleColorFacetSelection,
        items: colorFacets,
        productType: productType,
        enableStockIndicator: (sizeFacets === null || sizeFacets === void 0 ? void 0 : sizeFacets.length) === 0 ? stock.enableStockIndicator : false
    }), isOfferedWithPrescriptions && /*#__PURE__*/ React__default.createElement(SunglassesRxableSelectContainer, {
        className: "sunglasses-ecomm-content__section",
        onChange: onRxRadioChange,
        selectedValue: selectWithRxLens
    }), showSizeFacets && /*#__PURE__*/ React__default.createElement(FacetPickerSize, {
        className: "sunglasses-ecomm-content__section",
        activeFacet: showActiveSizeFacet ? activeSizeFacet : undefined,
        onPick: handleSizeFacetSelection,
        items: sizeFacets,
        productType: productType,
        notificationType: requiresUserSizeSelection ? notificationType : undefined,
        enableStockIndicator: showActiveSizeFacet ? stock.enableStockIndicator : false
    }), Slots.DynamicDeliveryIndicator ? /*#__PURE__*/ React__default.createElement(Slots.DynamicDeliveryIndicator, {
        isExcludedFromCheckout: isExcludedFromCheckout,
        deliveryItems: [
            {
                sku: activeSku,
                quantity: 1
            }
        ],
        withRxLens: shouldOpenConfigurator
    }) : null, /*#__PURE__*/ React__default.createElement("div", {
        ref: ctaRef
    }, CTAButton, isVtoEnabled && isVtoFeatureEnabled && /*#__PURE__*/ React__default.createElement(TryOnButton, null)), /*#__PURE__*/ React__default.createElement(ClickAndReserve, {
        sku: activeSku,
        onInvalidClick: !isValid ? triggerAlertMessage : undefined
    }), isVirtualMirrorEnabled && isVtoActive && /*#__PURE__*/ React__default.createElement(VirtualMirrorModal, {
        variants: mappedVTOVariants
    }), Slots.AfterCTA ? /*#__PURE__*/ React__default.createElement(Slots.AfterCTA, null) : null, Slots.Configurator && /*#__PURE__*/ React__default.createElement(Slots.Configurator, {
        id: "rxSun",
        onModalClose: handleConfiguratorClose,
        isOpen: isConfiguratorOpen
    }));
};

export { SunglassesEcommContent };
//# sourceMappingURL=SunglassesEcommContent.js.map
